import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker'
import { MatSnackBar } from '@angular/material/snack-bar'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class AppVersionsUpdateService {

  constructor(private swUpdate: SwUpdate, private readonly snackBar: MatSnackBar, private readonly translator: TranslateService) {}

  checkForUpdate(): Subscription {
    console.log(`Calling SwUpdate to check for new app Version`);
    return this.swUpdate.versionUpdates
      .subscribe((evt) => {
        switch (evt.type) {
          case 'VERSION_DETECTED':
            console.log(`Downloading new app version: ${evt.version.hash}`);
            break;
          case 'VERSION_READY':
            console.log(`Current app version: ${evt.currentVersion.hash}`);
            console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
            this.promptUser('NEW_ANGULAR_UPDATE');
            break;
          case 'VERSION_INSTALLATION_FAILED':
            console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
            this.promptUser('NEW_ANGULAR_UPDATE_ERROR');
            break;
        }
      });
  }

  swUpdateIsEnabled() {
    return this.swUpdate.isEnabled;
  }

  private promptUser(messages: string) {
    const snackbarRef = this.snackBar.open(this.translator.instant(messages), 'Reload', {
      panelClass: 'blue-snackbar',
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });

    snackbarRef.onAction().subscribe(()=>{
      window.location.reload();
    })
  }
}
